import { replaceTokens, urlJoin } from '@sleepstation/utils'
import PORTAL from '../../data/portal'
import { patchQuizData } from '../../helpers/quiz'
import { getRelation } from '../relation'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getPath = (namespace) => (path) => urlJoin(`/`, namespace, path)

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const getPortal = ({ portalNamespace }) => {
  const portal = getRelation(PORTAL, portalNamespace)

  return {
    ...portal,
    helpers: {
      getPath: getPath(portalNamespace),
      getLicenceSignupPath: () =>
        replaceTokens(`#{railsApp}/#{licenceSignupPath}`, {
          licenceSignupPath: portal.licenceSignupPath,
        }),
      getHasActiveLicences: () => portal.hasActiveLicences,
    },
    api: {
      patchQuizData: patchQuizData(portalNamespace),
    },
  }
}
